import { apiV4 } from './utils';

export const trackEvent = (baseURL: string, body: any) =>
  apiV4({
    baseURL,
    method: 'post',
    url: '/event',
    body,
  });
